module.exports = __webpack_public_path__ + "img/rop.878d30dd.svg";